import React, { useState, useEffect } from 'react';
import { creditoApi } from '../../../../api';
import './InfoCredito.css';

const InfoCredito = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    creditoApi.getInfoCompleta()
      .then(setInfo)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="dash-loading"><div className="spinner"></div></div>;
  if (error) return <div className="dash-alert dash-alert--error">{error}</div>;

  const { tipo, detalle, requisitos, condiciones } = info;
  const condList = condiciones?.data || condiciones || [];

  return (
    <div>
      <h2 className="dash-section-title">Información del Crédito</h2>
      <p className="dash-section-sub">Condiciones, requisitos y características del préstamo disponible</p>

      {/* Tipo + Detalle */}
      <div className="info-top-grid">
        {tipo && (
          <div className="dash-card info-tipo-card">
            <div className="info-tipo-card__header">
              <i className="fa-solid fa-landmark"></i>
              <div>
                <h3>{tipo.nombre}</h3>
                <span>Tipo de crédito ID {tipo.id}</span>
              </div>
            </div>
            {tipo.descripcion && <p>{tipo.descripcion}</p>}
          </div>
        )}
        {detalle && (
          <div className="dash-card info-detalle-card">
            <h3>{detalle.nombre}</h3>
            <div className="info-detalle-grid">
              <div><label>Monto mínimo</label><strong>S/ {detalle.monto_minimo}</strong></div>
              <div><label>Monto máximo</label><strong>S/ {detalle.monto_maximo}</strong></div>
              <div><label>Plazo mínimo</label><strong>{detalle.plazo_minimo} mes</strong></div>
              <div><label>Plazo máximo</label><strong>{detalle.plazo_maximo} meses</strong></div>
              <div className="span2"><label>Tasa de interés</label><strong className="tasa">{detalle.tasa_interes}% mensual</strong></div>
            </div>
          </div>
        )}
      </div>

      {/* Requisitos */}
      {requisitos?.length > 0 && (
        <div className="dash-card">
          <h3 className="info-subtitle"><i className="fa-solid fa-list-check"></i> Requisitos</h3>
          <div className="info-req-list">
            {requisitos.map((r) => (
              <div className="info-req" key={r.id}>
                <div className="info-req__icon">
                  <i className={r.obligatorio ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'}></i>
                </div>
                <div>
                  <strong>{r.nombre}</strong>
                  {r.descripcion && <p>{r.descripcion}</p>}
                  {r.obligatorio && <span className="info-req__badge">Obligatorio</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Condiciones */}
      {condList.length > 0 && (
        <div className="dash-card">
          <h3 className="info-subtitle"><i className="fa-solid fa-file-contract"></i> Condiciones</h3>
          <div className="info-req-list">
            {condList.map((c) => (
              <div className="info-req" key={c.id}>
                <div className="info-req__icon info-req__icon--cond">
                  <i className="fa-solid fa-circle-exclamation"></i>
                </div>
                <div>
                  <strong>{c.nombre}</strong>
                  {c.descripcion && <p>{c.descripcion}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Estados */}
      <div className="dash-card">
        <h3 className="info-subtitle"><i className="fa-solid fa-timeline"></i> Estados de la solicitud</h3>
        <div className="info-estados">
          {[
            { e: 'BORRADOR', desc: 'Recién creada desde el portal', c: '#777' },
            { e: 'PENDIENTE_REQUISITOS', desc: 'En revisión de documentos', c: '#f39c12' },
            { e: 'PENDIENTE_APROBACION', desc: 'En comité de aprobación', c: '#8e44ad' },
            { e: 'APROBADO', desc: 'Aprobado, pendiente desembolso', c: '#27ae60' },
            { e: 'DESEMBOLSADO', desc: 'Crédito entregado', c: '#1a4e8a' },
            { e: 'RECHAZADO', desc: 'Rechazada por el analista', c: '#c0392b' },
          ].map(({ e, desc, c }) => (
            <div className="info-estado" key={e}>
              <span className="sol-badge" style={{ background: c }}>{e}</span>
              <span>{desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfoCredito;
